import { updateGuaranteesV2 } from './http'
import { fromGuaranteeResponses, toRequests } from '../models/mapper'
import { GuaranteeUpdate } from '../models/request'
import { Guarantee } from '../models/types'

// eslint-disable-next-line import/prefer-default-export
export async function updateGuarantees(updates: GuaranteeUpdate[]): Promise<Guarantee[]> {
  const responses = await updateGuaranteesV2(toRequests(updates))

  return fromGuaranteeResponses(responses)
}
